import React, { useEffect, useState } from 'react';
import Loading from '../../../components/loading/Loading';
import useStyles from './styles';
import { Box, Typography } from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import StancerOneOffPaymentContainer from './StancerOneOffPaymentContainer';
import StancerPaymentMethods from './StancerPaymentMethods';

/**
 * @name StancerPaymentContainer - jsx component for Stancer flow
 * @param {object} props - Object containing react props
 * @returns {JSX.Element} - Renders StancerPaymentContainer component
 */
const StancerPaymentContainer = props => {
    const graphql = useApolloClient();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        props.setHeader('Payment summary');
    }, []);

    return (
        <React.Fragment>
            <Box className={classes.paymentBox}>
                {loading && <Loading />}
                {!loading && (
                    <>
                        <Typography variant='h6' className={classes.amount}>
                            Pay:€{props?.payableAmount}
                        </Typography>

                        <StancerPaymentMethods
                            payableAmount={props?.payableAmount}
                            handleBack={props?.handleBack}
                            setStatus={props?.setStatus}
                            handleNext={props?.handleNext}
                            setHeader={props?.setHeader}
                            handleMultiPaymentData={props?.handleMultiPaymentData}
                            toggle={props?.toggle}
                            setPaidAmount={props?.setPaidAmount}
                        />
                    </>
                )}
            </Box>
        </React.Fragment>
    );
};

export default StancerPaymentContainer;
